<!-- 账户信息 -->
<template>
    <div class="content">
        <div class="account">
            <h3><span>账户信息</span></h3>
            <div class="account-info">
                <el-form label-position="top" label-width="80px" :model="UserInfo">
                    <el-form-item label="头像">
                        <el-upload class="upload-demo" drag :show-file-list="false" :action="uploadcfg.url"
                            :headers="uploadcfg.header" :name="uploadcfg.name" :data="uploadcfg.data"
                            accept=".jpeg,.jpg,.png" :on-success="uploaded">
                            <div class="xcol ai-c jc-c pdv10">
                                <img :src="UserInfo.HeadImage" @error="defImg" class="avrtar">
                                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                                <!-- <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div> -->
                            </div>
                        </el-upload>
                    </el-form-item>
                    <el-form-item label="使用单位">
                        <el-input v-model="UserInfo.CompanyName"></el-input>
                    </el-form-item>
                    <el-form-item label="联系人">
                        <el-input v-model="UserInfo.Person"></el-input>
                    </el-form-item>
                    <el-form-item label="联系电话">
                        <el-input v-model="UserInfo.Mobile"></el-input>
                    </el-form-item>
                    <el-form-item label="单位详细地址">
                        <el-input v-model="UserInfo.Address">
                            <template slot="prepend">{{ UserInfo.Province + UserInfo.City + UserInfo.County +
                                UserInfo.Town }}</template>
                        </el-input>
                    </el-form-item>
                </el-form>
                <el-row>
                    <el-col :span="24" :offset="12">
                        <el-button type="primary" icon="el-icon-edit" @click="submitForm">保存</el-button>
                    </el-col>
                </el-row>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
//import config from '../../config.js'
export default {
    name: 'account',
    data() {
        return {
            UserInfo: {},
            defaultImg: require('../../assets/sctx.jpg'),
           // config
        }
    },

    computed: {
        ...mapState(['token']),
        uploadcfg() {
            return {
                //  url: config.remote + '/res/uploadImg',
                url: '/res/uploadImg',
                header: { 'Access-Token': this.token },
                name: 'AvatarImage',
                data: {
                    Kind: 1,
                    SubKind: 0
                }
            }
        }
    },

    mounted() {
        this.loadData()
    },

    methods: {
        defImg() {
            let img = event.srcElement
            img.src = this.defaultImg
            img.onerror = null // 防止闪图
        },
        uploaded(response, file, fileList) {
            console.log(response, file, fileList)
            if (response.code === 1) {
                this.UserInfo.HeadImage = response.data.FilePath
            }
        },
        loadData() {
            this.$request('user', 'info').then(res => {
                this.UserInfo = res.data
            })
        },
        submitForm() {
            this.$request('user', 'submit', {
                Person: this.UserInfo.Person,
                HeadImage: this.UserInfo.HeadImage,
                CompanyName: this.UserInfo.CompanyName,
                Mobile: this.UserInfo.Mobile,
                Address: this.UserInfo.Address
            }).then(res => {
                if (res.code === 1) {
                    this.$message({
                        message: '保存成功',
                        type: 'success'
                    })
                    this.$store.dispatch('refreshUserInfo')
                } else {
                    this.$message.error('保存失败')
                }
            })
        }
    }
}
</script>
<style lang='less' scoped>
.content {
    position: relative;
    left: 165px;
    top: 90px;
    width: calc(100vw - 175px);
    height: calc(100vh - 90px);
    overflow-y: auto;
    overflow-x: hidden;
    padding: 30px;
}
.account {
    background-color: #fff;
    padding: 30px;
    border-radius: 10px;
    text-align: left;
    h3 {
        padding-bottom: 25px;
        border-bottom: solid 1px #ededed;

        span {
            color: #090e15;
            font-size: 20px;
            letter-spacing: 2px;
            font-weight: bold;
            display: block;
            line-height: 28px;
            background: url(../../assets/category/te-5.png) no-repeat left center;
            padding-left: 40px;
        }
    }
}

.account-info .avrtar {
    width: 120px;
    height: 120px;
    margin: 0 auto;
    position: relative;
}

.el-upload-dragger {
    height: 180px !important;
    // width: 200px !important;
}
.el-form-item {
    margin-bottom: 22px;
    text-align: left;
}
</style>
